<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">商品名称：</span>
					<el-input v-model="search_name" class="b_inp" placeholder="商品名称"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchStartDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchEndDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">疾病：</span>
					<el-select v-model="search_disease" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in disease" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增商品</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="id"
						label="序号"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="商品名称"
					>
					</el-table-column>
					<el-table-column
						prop="price"
						label="商品价格/元"
					>
					</el-table-column>
					<el-table-column
						prop="oldPrice"
						label="商品原价格/元"
					>
					</el-table-column>
					<el-table-column
						prop="factoryPrice"
						label="出厂价格/元"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						prop="publisher"
						label="发布人"
					>
					</el-table-column>
					<el-table-column
						prop="diseaseNames"
						label="疾病"
					>
					</el-table-column>
					<el-table-column
						prop="virtualLabel"
						label="是否虚拟产品"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增 -->
		<add
			v-model="add_display"
			:diseaseList="disease"
			@onSuccess="addSuccess"
		></add>
		<!-- 新增 end -->
		
		<!-- 查看 -->
		<view-goods
			v-model="view_display"
			:obj="view_data"
			:diseaseList="disease"
		></view-goods>
		<!-- 查看 end -->
		
		<!-- 修改 -->
		<update
			v-model="update_display"
			:diseaseList="disease"
			:obj="update_data"
			@onSuccess="updateSuccess"
		></update>
		<!-- 修改 end -->
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import ViewGoods from './components/view.vue';
	import Update from './components/update.vue';
	import Api from '../../../../../../api/index.js';
	
	export default{
		mounted() {
			this.findDisease();
		},
		data() {
			return{
				loading: false,
				disease: [],
				
				search_name: '',
				search_startDate: '',
				search_endDate: '',
				search_disease: '',
				
				total: 0,
				currentPage: 1,
				tableData: [],
				
				add_display: false,
				
				view_display: false,
				view_data: {},
				
				update_display: false,
				update_data: {}
			}
		},
		methods: {
			/******************** @Events *************************/
			// 开始时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 结束时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.findGoods();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.findGoods();
				}
			},
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 点击查看
			handleViewClick(data) {
				this.view_data = {...data};
				this.view_display = true;
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			// 点击删除
			handleDeleteClick(obj) {
				const that = this;
				that.$confirm(
					'此操作将删除该商品，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteGoods(obj.id);
					}
				).catch(
					() => {}
				);
			},
			
			/******************** @Function *************************/
			// 获取所有疾病
			findDisease() {
				const that = this;
				that.loading = true;
				Api.findDiseaseForAppAndMall({typeChannel: 2}).then((res) => {
					if (res.data.success) {
						let list = [];
						res.data.data.forEach(v => {
							list.push({
								id: v.id,
								name: v.diseaseName
							});
						});
						that.disease = list;
						that.findGoods();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取商品列表
			findGoods() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					goodsName: that.search_name,
					start: that.search_startDate,
					end: that.search_endDate,
					diseaseId: that.search_disease,
					typeChannel: 2
				};
				Api.findGoodsForAppAndMall(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								name: v.goodsName,
								price: v.goodsDiscountPriceYuan,
								oldPrice: v.goodsPriceYuan,
								factoryPrice: v.goodsFactoryPriceYuan,
								time: v.createTs,
								publisher: v.buserName,
								diseaseIds: that.getGoodsDiseaseIds(v.goodsDiseases),
								diseaseNames: that.getGoodsDiseaseNames(v.goodsDiseases),
								isVirtual: v.virtual,
								days: v.days,
								times: v.times,
								trainingProduct: v.productId == undefined ? -1 : v.productId,
								virtualLabel: v.virtual == 1 ? '是' : '否',
								post: v.goodsSmallIcon,
								infoPic: v.goodsImgs.split(','),
								carousels: v.carouselMap.split(','),
								desc: v.goodsDesc,
								fare: v.freight,
								cardImg: v.cardImg || '',
								monthSale: v.monthlySales || ''
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增成功
			addSuccess() {
				this.findGoods();
			},
			// 修改成功
			updateSuccess() {
				this.findGoods();
			},
			// 得到商品疾病id
			getGoodsDiseaseIds(list) {
				let arr = [];
				list.forEach(v => {
					arr.push(v.diseaseId);
				});
				return arr;
			},
			// 得到商品疾病名称
			getGoodsDiseaseNames(list) {
				let name = '';
				list.forEach(v => {
					name += `${ v.diseaseName },`;
				});
				name && (name = name.slice(0, name.length - 1));
				return name;
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startTime = new Date(this.search_startDate).getTime(),
						endTime = new Date(this.search_endDate).getTime();
					if (endTime < startTime) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			},
			// 删除商品
			deleteGoods(id) {
				const that = this;
				that.loading = true;
				Api.deleteGoodsForAppAndMall(id, {typeChannel: 2}).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.findGoods();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			Add,
			ViewGoods,
			Update
		}
	}
</script>

<style scoped>
</style>
